import ImageSlider from "./common/ImageSlider";
import ProjectInfo from "./project-details/ProjectInfo";
import ProjectDescription from "./project-details/ProjectDescription";
import Footer from "./Footer";
import Header from "./Header";

const CyberSynopsis = () => {
  const images = [
    "assets/img/portfolio/cybersynopsis.png",
    "assets/img/portfolio/cybersynopsis2.png",
    "assets/img/portfolio/cybersynopsis3.png",
    "assets/img/portfolio/cybersynopsis4.png",
  ];
  const projectData = {
    title: "CyberSynopsis",
    stack: "Wordpress",
    projectUrl: "https://cybersynopsis.co.za/",
    description: "cyberDesc",
  };

  return (
    <>
      <Header />
      <main id="main">
        <section className="portfolio-details">
          <div className="container">
            <div className="row gy-4">
              <ImageSlider images={images} />

              <div className="col-lg-4">
                <ProjectInfo
                  stack={projectData.stack}
                  projectUrl={projectData.projectUrl}
                />
                <ProjectDescription descriptionKey={projectData.description} />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default CyberSynopsis;
